function isVisible(element) {
  if (!element) return false;

  const style = window.getComputedStyle(element);

  return style.display !== 'none'
    && style.visibility !== 'hidden'
    && style.opacity !== '0'
    && element.getClientRects().length > 0;
}

export function openVLibras() {
  const wrapper = document.querySelector('#vlibras-access-wrapper');
  const openBtn = wrapper?.shadowRoot?.querySelector('#vlibras-button');
  const widgetWrapper = document.querySelector('#vlibras-app-root');
  const widget = widgetWrapper?.shadowRoot?.querySelector('#vlibras-app');
  const dropdownBtn = document.querySelector('button.br-button.circle.small.active');
  const dropdownDiv = document.querySelector('div.header-functions.dropdown.show');

  if (dropdownBtn && dropdownDiv) {
    dropdownBtn.classList.remove('active');
    dropdownDiv.classList.remove('show');
  }

  if (openBtn && !isVisible(widget)) {
    openBtn.click();
  }
}